import './kockys/style';
import FormStructure from './kockys/form_structure';

export default FormStructure;